export default __webpack_public_path__ + "static/media/instagram.bd6fb48e.svg";